module.exports = __webpack_public_path__ + "img/icon9.13bea368.png";